import { Drawer, Select, message, Tooltip } from "antd";
import { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { promocodeValidation } from "../../../utils/validations/formValidations";
import CodeNameIcon from "../../../assets/code-name.svg";
import DiscountIcon from "../../../assets/discount.svg";
import CalendarIcon from "../../../assets/promotion-calendar.svg";
import UsageLimitIcon from "../../../assets/usage-limit.svg";
import CategoryIcon from "../../../assets/promotion-category.svg";
import DescriptionIcon from "../../../assets/description.svg";
import {
  AddPromotion,
  GetAllCategories,
  // GetCategories,
  UpdatePromotion,
} from "../../../utils/api";
import { getFromLocalStorage } from "../../../utils/storageUtil";
import "./AddUpdatePromotion.css";
import dayjs from "dayjs";

const AddUpdatePromotion = ({
  updatePromotionData,
  setUpdatePromotionData,
}) => {
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [isPercentage, setIsPercentage] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
    reset,
  } = useForm({ resolver: yupResolver(promocodeValidation) });

  const onSubmit = async (data) => {
    const body = {
      ...data,
      startDate: new Date(),
      type: getFromLocalStorage("admin")?.user_type,
      discountType: isPercentage ? "percentage" : "flat",
    };
    if (updatePromotionData?.data?.id) {
      try {
        setLoading(true);
        const resData = await UpdatePromotion(
          body,
          updatePromotionData?.data?.id
        );
        if (resData?.isSuccess) {
          message.success("Promocode Updated Successfully.");
          setUpdatePromotionData({ visible: false, data: null });
        } else {
          message.destroy();
          message.error(resData?.error);
        }
      } catch (error) {
        message.error(
          "An error occurred during the process. Please try again later.`"
        );
      } finally {
        setLoading(false);
      }
    } else {
      try {
        setLoading(true);
        const resData = await AddPromotion(body);
        if (resData?.isSuccess) {
          message.success("Promocode Added Successfully.");
          setUpdatePromotionData({ visible: false, data: null });
          reset();
        } else {
          message.destroy();
          message.error(resData?.error);
        }
      } catch (error) {
        message.error(
          "An error occurred during the process. Please try again later.`"
        );
      } finally {
        setLoading(false);
      }
    }
  };

  const handleTogglePercentage = () => {
    setIsPercentage((prev) => !prev);
  };

  const handleCancel = () => {
    setUpdatePromotionData({ visible: false, data: null });
    reset();
  };

  const handleSelectAll = (allCategoryKeys, onChange) => {
    onChange(allCategoryKeys);
  };

  useEffect(() => {
    if (updatePromotionData && updatePromotionData.data) {
      const formFields = [
        "name",
        "discount",
        "endDate",
        "usageLimit",
        "categoryIds",
        "description",
      ];
      const formDataToUpdate = {};
      formFields.forEach((fieldName) => {
        if (updatePromotionData.data.hasOwnProperty(fieldName)) {
          formDataToUpdate[fieldName] = updatePromotionData.data[fieldName];
        }
      });
      // Object.keys(formDataToUpdate).forEach((fieldName) => {
      //   setValue(fieldName, formDataToUpdate[fieldName]);
      // });
      Object.keys(formDataToUpdate).forEach((fieldName) => {
        if (fieldName === "categoryIds") {
          const selectedCategoryIds = updatePromotionData.data.categoryIds.map(
            (categoryId) => categoryId
          );
          setValue(fieldName, selectedCategoryIds);
        } else {
          setValue(fieldName, formDataToUpdate[fieldName]);
        }
      });
      setIsPercentage(
        updatePromotionData?.data?.discountType === "percentage" ? true : false
      );
    }
  }, [setValue, updatePromotionData]);

  useEffect(() => {
    const getCategoriesList = async () => {
      // const response = await GetCategories();
      // setCategories(
      //   response?.items?.map((item) => ({
      //     label: item.name,
      //     key: item.name,
      //   }))
      // );
      const response = await GetAllCategories();
      setCategories(
        response?.items?.map((item) => ({
          label: item.name,
          key: item.id,
        }))
      );
    };
    getCategoriesList();
  }, [updatePromotionData.visible]);

  return (
    <Drawer
      contentWrapperStyle={{ width: "500px" }}
      className="send-email_drawer"
      title={`${!updatePromotionData?.data ? "Add" : "Update"} Promo Code`}
      placement="right"
      onClose={handleCancel}
      open={updatePromotionData?.visible}
    >
      {/* Body */}
      <div className="px-8 py-4 promotions">
        <form
          className="flex flex-col mt-6"
          onSubmit={handleSubmit(onSubmit)}
          noValidate
        >
          <div className="mb-6">
            <div className="border border-input-placeholder flex items-center gap-x-2 rounded-lg p-3 relative">
              <label
                className="absolute bg-white text-input-label -top-2 left-5 text-[11px] px-1"
                htmlFor="name"
              >
                Code Name
              </label>
              <img src={CodeNameIcon} alt="code-name" />
              <input
                className="w-full outline-none text-[12px] text-input-placeholder"
                type="text"
                placeholder="Name"
                id="name"
                {...register("name")}
              />
            </div>
            <p className="text-[red] text-[12px]">{errors.name?.message}</p>
          </div>

          <div className="mb-6">
            <div className="border border-input-placeholder flex items-center gap-x-2 rounded-lg p-3 relative">
              <label
                className="absolute bg-white text-input-label -top-2 left-5 text-[11px] px-1"
                htmlFor="discount"
              >
                Discount
              </label>
              <img src={DiscountIcon} alt="discount-name" />
              <input
                className="w-full outline-none text-[12px] text-input-placeholder"
                type="number"
                placeholder="Discount"
                id="discount"
                {...register("discount")}
              />
              <Tooltip placement="top" title={<span>Click to change</span>}>
                <button onClick={handleTogglePercentage} type="button">
                  {isPercentage ? "%" : "£"}
                </button>
              </Tooltip>
            </div>
            <p className="text-[red] text-[12px]">{errors.discount?.message}</p>
          </div>

          <div className="mb-6">
            <div className="border border-input-placeholder flex items-center gap-x-2 rounded-lg p-3 relative">
              <label
                className="absolute bg-white text-input-label -top-2 left-5 text-[11px] px-1"
                htmlFor="endDate"
              >
                Expiry Date
              </label>
              <img src={CalendarIcon} alt="calender-name" />
              <input
                className="w-full outline-none text-[12px] text-input-placeholder"
                type="date"
                id="endDate"
                {...register("endDate")}
                min={new Date().toISOString().split("T")[0]}
              />
            </div>
            <p className="text-[red] text-[12px]">{errors.endDate?.message}</p>
          </div>

          <div className="mb-6">
            <div className="border border-input-placeholder flex items-center gap-x-2 rounded-lg p-3 relative">
              <label
                className="absolute bg-white text-input-label -top-2 left-5 text-[11px] px-1"
                htmlFor="usageLimit"
              >
                Usage Limit
              </label>
              <img src={UsageLimitIcon} alt="limit-name" />
              <input
                className="w-full outline-none text-[12px] text-input-placeholder"
                type="number"
                placeholder="Limit"
                id="usageLimit"
                {...register("usageLimit")}
              />
            </div>
            <p className="text-[red] text-[12px]">
              {errors.usageLimit?.message}
            </p>
          </div>

          <div className="mb-6">
            <div className="border border-input-placeholder flex items-center gap-x-2 rounded-lg pl-3 py-1 relative">
              <label
                className="absolute z-40 bg-white text-input-label -top-2 left-5 text-[11px] px-1"
                htmlFor="categoryName"
              >
                Category
              </label>
              <img src={CategoryIcon} alt="category-name" />
              {/* <Controller
                control={control}
                name="categoryName"
                render={({ field }) => (
                  <Select
                    mode="multiple"
                    placeholder="Select Category"
                    {...field}
                    value={field.value}
                    className="promotions w-full outline-none text-[12px] text-input-placeholder"
                  >
                    {categories?.length &&
                      categories?.map((foo) => (
                        <Select.Option
                          value={foo.key}
                          key={foo.key}
                          // className="last:pb-6"
                        >
                          {foo.label}
                        </Select.Option>
                      ))}
                  </Select>
                )}
              /> */}
              <Controller
                control={control}
                name="categoryIds"
                render={({ field: { onChange, value } }) => (
                  <Select
                    mode="multiple"
                    showSearch={false}
                    placeholder="Select Category"
                    value={value}
                    onChange={(selectedValues) => {
                      if (selectedValues.includes("all")) {
                        handleSelectAll(
                          categories.map((category) => category.key),
                          onChange
                        );
                      } else {
                        onChange(selectedValues);
                      }
                    }}
                    className="promotions w-full outline-none text-[12px] text-input-placeholder"
                  >
                    <Select.Option value="all">Select All</Select.Option>
                    {categories?.map((category) => (
                      <Select.Option value={category.key} key={category.key}>
                        {category.label}
                      </Select.Option>
                    ))}
                  </Select>
                )}
              />
            </div>
            <p className="text-[red] text-[12px]">
              {errors.categoryName?.message}
            </p>
          </div>

          <div className="mb-6">
            <div className="border border-input-placeholder flex items-center gap-x-2 rounded-lg p-3 relative">
              <label
                className="absolute bg-white text-input-label -top-2 left-5 text-[11px] px-1"
                htmlFor="description"
              >
                Description
              </label>
              <img src={DescriptionIcon} alt="description-name" />
              <input
                className="w-full outline-none text-[12px] text-input-placeholder"
                type="text"
                id="description"
                placeholder="Description"
                {...register("description")}
              />
            </div>
            <p className="text-[red] text-[12px]">
              {errors.description?.message}
            </p>
          </div>

          {/* Actions */}
          <div className="mt-6 flex items-center justify-center gap-x-3">
            <span
              className=" bg-white flex-1 text-center text-primary-700 border border-primary-700 text-[10px] px-6 py-3 rounded-lg cursor-pointer"
              onClick={handleCancel}
            >
              Back
            </span>
            <button
              disabled={loading}
              className="flex-1 text-center bg-primary-700 border border-primary-700 text-white text-[10px] px-6 py-3 rounded-lg cursor-pointer flex items-center justify-center gap-x-2"
            >
              Submit
              {loading && <span className="loader"></span>}
            </button>
          </div>
        </form>
      </div>
    </Drawer>
  );
};

export default AddUpdatePromotion;
